export function getPageType(pathname: string) {
  const splited = pathname.split('/');
  const filtered = splited.filter((x, i) => i > 1);
  return filtered.join('/');
}

export function getPageClass(pathname: string) {
  const splited = pathname.split('/');
  return splited.length > 2 ? splited[2] : null;
}
